  /* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
import { Tr } from '../../../../_metronic/i18n/Tr';
import { LANG_SYNCED_KEY, SUPPORTED_LANGS, getSelectedLang, isUserSelectedLang, saveLanguage, syncLanguageToProfile } from '../../../../_metronic/i18n/Metronici18n';

export function Login() {
  const t = Tr();
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState("") as any;
  const [password, setPassword] = useState("") as any
  const [error, setError] = useState({ "email": "", "password": "" })
  const [datapost, setDatapost] = useState(false)
  const navigate = useNavigate()
  const [passwordDisplay, setPasswordDisplay] = useState(false)

  const validate = (submited: any = false) => {
    setDatapost(true)
    var tmpErr = error
    if (email == "" || email == null) {
      tmpErr["email"] = t("Email Required")
    }
    else {
      tmpErr["email"] = ""
    }
    if (password == "" || password == null) {
      tmpErr["password"] = t("Password Required")
    }
    else {
      tmpErr["password"] = ""
    }

    if (tmpErr["email"] == "" && tmpErr["password"] == "" && submited == true) {
      loginapicall()
    }
  }

  const loginapicall = async () => {
    setLoading(true)
    var param: any = {
      email: email,
      password: password,
      type: "Vendor"
    }
    var response: any = await fetchData("public/login", param)

    if (response.status == "200") {
      var data = response.data[0];
      if (data.block == '1') {
        Swal.fire({
          title: t("Admin has blocked Your Account."),
          text: t('Please Contact Admin For Further Inquiry'),
          icon: 'warning',
        }).then(async (result) => {
          if (result.isConfirmed || result.isDismissed) {
            setLoading(false)
            setEmail("")
            setPassword("")
          }
        });
      } else {
        const state = {
          vendorId: data['vendorId']
        }
        if (data['isBusinessInformationSubmit'] == 0 && data['businessInfostatus'] != 2) {
          navigate("../personaldetails/", { state });
        } else if (data['businessInfostatus'] == 0 || data['businessInfostatus'] == 2) {
          navigate("../businesspending/", { state });
        } else {
          var arr = {
            fullName: data.fullName,
            email: data.email,
            mobile_number: data.mobileNumber,
            profile_picture: data.logo,
            location: data.location,
            vendorId: data.vendorId,
          }

          sessionStorage.setItem("categoryId", data.categoryId);
          sessionStorage.setItem("isAddedOpeningHours", data.isAddedOpeningHours);
          sessionStorage.setItem("isAddedPolicy", data.isAddedPolicy);
          sessionStorage.setItem("vendor", JSON.stringify(arr))
          sessionStorage.setItem("loginTimestamp", Date.now().toString())

          // language at login: an explicit choice made on this browser is kept and pushed
          // to the profile, otherwise the profile language becomes the default
          sessionStorage.setItem(LANG_SYNCED_KEY, '1')
          if (isUserSelectedLang()) {
            await syncLanguageToProfile(getSelectedLang())
          } else if (data.language && SUPPORTED_LANGS.includes(data.language)) {
            saveLanguage(data.language)
          } else {
            sessionStorage.removeItem(LANG_SYNCED_KEY)
          }
          toastsuccessmsg(t("Login Successfully"))

          setTimeout(() => {
            setLoading(false)
            window.location.reload();
          }, 1500);
        }
      }

    }
    else {
      setLoading(false)
      toasterrormsg(response.message)
    }
  }

  return (
    <>
      <ToastContainer />
      <div
        className='form w-100'
        id='kt_login_signin_form'
      >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          <h1 className='text-dark fw-bolder mb-3'>{t('Sign In')}</h1>
        </div>
        {/* begin::Heading */}

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fs-6 fw-bolder text-dark'>{t('Email')}</label>
          <input
            placeholder={t('Email')}
            className='form-control bg-transparent'
            type='email'
            name='email'
            autoComplete='off'
            value={email}
            onChange={(e: any) => { setEmail(e.target.value); if (datapost == true) { validate() } }}
            onKeyDown={(e: any) => { if ((e.key === 'Enter' || e.keyCode === 13) && email != "" && email != null && password != "" && password != null) { validate(true) } }}
          />
          {
            error['email'] != "" && <span className='text-danger'>{error['email']}</span>
          }
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='fv-row mb-3' style={{ position: "relative" }}>
          <label className='form-label fw-bolder text-dark fs-6 mb-0'>{t('Password')}</label>
          <div style={{ position: "relative" }}>
            <input
              type={passwordDisplay == true ? "text" : "password"}
              autoComplete='off'
              placeholder={t('Password')}
              className='form-control bg-transparent'
              value={password}
              onChange={(e: any) => { setPassword(e.target.value); if (datapost == true) { validate() } }}
              onKeyDown={(e: any) => { if ((e.key === 'Enter' || e.keyCode === 13) && email != "" && email != null && password != "" && password != null) { validate(true) } }}
            />
            <span className="cursor-pointer" style={{ position: "absolute", top: "25%", right: "20px" }} title={passwordDisplay == true ? "Hide" : "Show"} onClick={() => setPasswordDisplay(!passwordDisplay)}><FontAwesomeIcon icon={passwordDisplay == true ? faEyeSlash : faEye} /></span>
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          {
            error['password'] != "" && <span className='text-danger'>{error['password']}</span>
          }
        </div>
        {/* end::Form group */}

        {/* begin::Wrapper */}
        <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
          <div />

          {/* begin::Link */}
          <Link to='/auth/forgot-password' className='link-primary'>
            {t('Forgot Password ?')}
          </Link>
          {/* end::Link */}
        </div>
        {/* end::Wrapper */}

        {/* begin::Action */}
        <div className='d-grid mb-10'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary'
            disabled={email != "" && email != null && password != "" && password != null ? false : true}
            onClick={() => validate(true)}
          >
            {!loading && <span className='indicator-label'>{t('Continue')}</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                {t('Please wait...')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Action */}

        <div className='text-gray-500 text-center fw-semibold fs-6'>
          {t('Not a Member yet?')}{' '}
          <Link to='/auth/registration' className='link-primary'>
            {t('Sign up')}
          </Link>
        </div>
      </div>
    </>
  )
}
